import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export interface ProductConfiguratorPDFData {
  designation: string;
  description: string;
  manufacturerLogoUrl: string;
  brandLogoUrl: string;
  imageUrl: string;
  steps: Step[];
}

interface Step {
  title: string;
  substepData: SubstepData[];
}

interface SubstepData {
  name: string;
  headerRow?: string[];
  dataRows: DataRowItem[][];
}

interface DataRowItem {
  value: string;
  standard: boolean;
}

interface ProductConfiguratorPDFDataWsDTO extends Omit<ProductConfiguratorPDFData, "steps"> {
  steps: Array<{
    title: string;
    substepData: Array<{
      name: string;
      headerRow?: string[];
      dataRows: Array<{ items: DataRowItem[] }>;
    }>;
  }>;
}

/** Encode the domain's nested row arrays using the concrete list envelope required by MOXy. */
export function toProductConfiguratorPDFDataWsDTO(data: ProductConfiguratorPDFData): ProductConfiguratorPDFDataWsDTO {
  return {
    ...data,
    steps: data.steps.map((step) => ({
      ...step,
      substepData: step.substepData.map((substep) => ({
        ...substep,
        dataRows: substep.dataRows.map((items) => ({ items })),
      })),
    })),
  };
}

export async function apiGenerateDatasheet(productCode: string, data: ProductConfiguratorPDFData) {
  const url = occUrl(`/configurator/${productCode}/download/datasheet`);

  const response = await occFetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(toProductConfiguratorPDFDataWsDTO(data)),
  });

  if (!response.ok) {
    throw new Error(`Failed to generate datasheet: ${response.statusText}`);
  }

  downloadBlobFromResponse(response);
}
